import { Component, Input, OnInit } from '@angular/core';

export interface PageActionOptions {
  id?: string;
  icon: string;
  title: string;
  callback: EventListener;
  disabled?: boolean;
  hidden?: boolean;
  type?: string;
  translationString?: string;
}

export class PageAction {
  constructor(public options: PageActionOptions) {
  }
}

@Component({
    selector: 'page-actions',
    templateUrl: './page-actions.component.html',
    styleUrls: ['./page-actions.component.scss'],
    standalone: false
})
export class PageActionsComponent implements OnInit {

  @Input()
  public pageActions: PageAction[];

  constructor() {
  }

  ngOnInit() {
  }

}
